var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSunGlassemojy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-38-emojy2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1536",
    "data-name": "Rectangle 1536",
    width: 38,
    height: 38,
    fill: "rgba(255,255,255,0)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cool-emoji",
    transform: "translate(3 3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_425",
    "data-name": "Path 425",
    d: "M15.866,0h0V0A15.853,15.853,0,0,1,31.727,15.864h0v0h0A15.853,15.853,0,0,1,15.866,31.727v0h0v0A15.848,15.848,0,0,1,.005,15.866H0v0H.005A15.857,15.857,0,0,1,15.866,0V0Zm6.8,19.97c-4.1,3.409-8.6,3.623-13.6,0,2.464,6.637,11.719,6.533,13.6,0ZM13.674,9.9a.935.935,0,0,1,.457.263,3.781,3.781,0,0,1,1.942-.527,3.444,3.444,0,0,1,1.578.431,2.419,2.419,0,0,1,1.792-.405,25.886,25.886,0,0,1,4.447.235.89.89,0,0,1,.367.181l2.216.537-1.6,1.273c.013.207.015.408.015.6a3.727,3.727,0,0,1-3.85,3.7,3.726,3.726,0,0,1-3.85-3.7c0-.449.008-.829.036-1.154a2.232,2.232,0,0,0-1.175-.393,2.609,2.609,0,0,0-1.436.455,7.993,7.993,0,0,1,.062,1.092,3.727,3.727,0,0,1-3.85,3.7,3.726,3.726,0,0,1-3.85-3.7c0-.243,0-.465.008-.671l-1.72-1.351,2.3-.509a2.809,2.809,0,0,1,1.66-.294,25.846,25.846,0,0,1,4.447.24Zm2.192-7.874v.005h0l0-.005A13.851,13.851,0,0,0,2.022,15.864h0v0h0A13.856,13.856,0,0,0,15.864,29.711v-.005h0v.005A13.851,13.851,0,0,0,29.708,15.866h0v0h.005A13.851,13.851,0,0,0,15.866,2.022Z",
    fill: "#1dbbbe"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSunGlassemojy);
export default __webpack_public_path__ + "static/media/sunGlassemojy.fc80e31dab9f2d912045fcbc02d259df.svg";
export { ForwardRef as ReactComponent };